import styled, { css } from 'styled-components';
import { layout } from '@prisjakt/ui-base';

interface IExpandButtonProps {
  $expanded: boolean;
  isAlternative?: boolean;
}

export const ExpandButton = styled.button<IExpandButtonProps>(
  props => css`
    display: flex;
    flex: 0 0 auto;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    outline: none;
    cursor: pointer;
    min-height: 100%;
    transition: background-color ${layout.animations.buttonTransition};
    background-color: transparent;
    padding: ${layout.measurements.spacing050};
    padding-left: ${layout.measurements.spacing100};
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;

    ${props.$expanded &&
      css`
        border-bottom-left-radius: 0;
      `}

    /* Small mobile resolutions, e.g. Galaxy Fold */
    @media screen and (max-width: 280px) {
      padding-left: ${layout.measurements.spacing050};
    }

    &:hover {
      background-color: ${props.theme.colors.base100};
    }

    &.focus-visible {
      outline: ${props.theme.text.linkExternalHover} dotted 1px;
      outline: -webkit-focus-ring-color auto 1px;
    }
  `
);
